import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onWheel, onKeyDown, onChange, min, ...props }, ref) => {
    // ڕاگرتنی سکرۆڵ لەسەر ئینپوتی ژمارە
    const handleWheel = React.useCallback((e: React.WheelEvent<HTMLInputElement>) => {
      if (type === "number") {
        e.currentTarget.blur();
      }
      onWheel?.(e);
    }, [type, onWheel]);

    // ڕێگری لە نووسینی - لە ئینپوتی ژمارە
    const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
      if (type === "number" && e.key === "-") {
        e.preventDefault();
      }
      onKeyDown?.(e);
    }, [type, onKeyDown]);

    // ڕێگری لە paste کردنی ژمارەی نێگەتیڤ
    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
      if (type === "number") {
        const value = e.target.value;
        if (value.includes("-")) {
          e.target.value = value.replace(/-/g, "");
        }
      }
      onChange?.(e);
    }, [type, onChange]);

    return (
      <input
        type={type}
        ref={ref}
        data-slot="input"
        onWheel={handleWheel}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        min={type === "number" ? (min ?? 0) : min}
        className={cn(
          "flex h-10 w-full rounded-xl border border-input bg-background px-3 py-2 text-base transition-all duration-150 ease-out",
          "placeholder:text-muted-foreground",
          "hover:border-muted-foreground/50",
          "focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          className
        )}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
